import type { IUserInput, ICalculation } from './ACHCalculator.types';

export const calculate = (userInput: IUserInput): ICalculation => {
  const achFixedFee = 0.2; // $0.20
  const ccFixedFee = 0.3; // $0.30
  const ccVariableFee = 2.9; // 2.9%
  const paymentsPerMonth =
    userInput.monthlyVolume / userInput.averagePaymentSize;

  // without PBB
  const ccPayments = paymentsPerMonth * userInput.months; // # of CC payments
  const ccVariableFeeDecimal = ccVariableFee / 100;
  const processingFees =
    ccPayments * ccVariableFeeDecimal * userInput.averagePaymentSize +
    ccPayments * ccFixedFee; // cc payment processing fees

  // with PBB
  const achAdoptionAsDecimal = userInput.achAdoption / 100;
  const ccPaymentsComparator =
    paymentsPerMonth * userInput.months * (1 - achAdoptionAsDecimal); // # of CC payments with PBB
  const achPayments =
    paymentsPerMonth * achAdoptionAsDecimal * userInput.months; // # of ACH payments with PBB
  const processingFeesComparator =
    ccPaymentsComparator * ccVariableFeeDecimal * userInput.averagePaymentSize +
    ccPaymentsComparator * ccFixedFee; // CC payment processing fees with PPB
  const achProcessingFees = achPayments * achFixedFee; // ACH payment processing fees with PBB
  const totalFees = processingFeesComparator + achProcessingFees; // total payment processing fees with PBB
  const savings = processingFees - totalFees; // savings

  return {
    afterPBB: Number.isNaN(totalFees) ? 0 : Math.ceil(totalFees),
    beforePBB: Number.isNaN(processingFees) ? 0 : Math.ceil(processingFees),
    savings: Number.isNaN(savings) ? 0 : Math.floor(savings),
  };
};
